"use strict";

require("core-js/modules/es.array.iterator");

var curry = require('./curry.js');

module.exports = curry(function apply(f, iter) {
  return f(...iter);
});